import loadable from "@app/utils/loadable";
import { Navigate } from "react-router-dom";
import { BusinessLineEnum } from "../constants/base";
// import { SUPPORT_LAYOUT } from 'constants/layout'
import { StrategyBusinessLine } from "constants/strategy";
import { PreFetchRouteObject } from "@app/utils/routesTypes";
// import { futureHomeLoadData } from 'pages/FuturesHome/load-data'
import { tdkQueryKeys } from "constants/queryKeys";
import { TDKServices } from "api/ssr";
import {
  // futuresTicker,
  // futuresPlaceConfig,
  // spotTicker,
  // getStrategyFuturesTicker,
  getStrategySpotTicker,
} from "api/ssr/ticker";
// import { tradebotHomeLoadData } from "container/TradingBot/load-data";
// import { cryptoHomeLoadData } from 'pages/Crypto/Home/load-data'
// import { Outlet } from 'react-router-dom'
// import {
//     preMarketCoinNewsQuery,
//     preMarketConfigsByMd5Query,
//     preMarketHistoryProjectQuery,
//     preMarketNewsProjectQuery,
//     preMarketSpotTickerQuery,
//     preMarketBannerQuery,
//     preMarketCoinConfigListQuery
// } from 'pages/PreMarket/load-data'

// export const ContractContainer = loadable(() => import('container/ContractContainer'), {
//     loading: true
// })
// const BusinessLine = loadable(() => import('./BusinessType'))
const Main = loadable(() => import("./Main"), {
  loading: true,
  ssr: false,
});

// const FuturesOverview = loadable(() => import('components/ContractIntroduction/FuturesOverview'), {
//     ssr: true,
//     loading: true
// })

// const MarginOverview = loadable(() => import('components/ContractIntroduction/MarginOverview'), {
//     ssr: true,
//     loading: true
// })

// const LiquidationOverview = loadable(
//     () => import('components/ContractIntroduction/LiquidationOverview'),
//     {
//         ssr: true,
//         loading: true
//     }
// )

// const OrderOverview = loadable(() => import('components/ContractIntroduction/OrderOverview'), {
//     ssr: true,
//     loading: true
// })

// const TradingFees = loadable(() => import('components/ContractIntroduction/TradingFees'), {
//     ssr: true,
//     loading: true
// })

// const ContractDetails = loadable(() => import('components/ContractIntroduction/ContractDetails'), {
//     ssr: false,
//     loading: true
// })
// const MarginDiscountRate = loadable(
//     () => import('components/ContractIntroduction/MarginDiscountRate'),
//     {
//         ssr: false,
//         loading: true
//     }
// )
// const MarginExchangeRate = loadable(
//     () => import('components/ContractIntroduction/MarginExchangeRate'),
//     {
//         ssr: false,
//         loading: true
//     }
// )
// const RateRecord = loadable(() => import('components/ContractIntroduction/RateRecord'), {
//     ssr: false,
//     loading: true
// })

// const TradingParameters = loadable(
//     () => import('components/ContractIntroduction/TradingParameters'),
//     {
//         ssr: false,
//         loading: true
//     }
// )

// const FundsRate = loadable(() => import('components/ContractIntroduction/FundsRate'), {
//     ssr: false,
//     loading: true
// })

// const OpenLimit = loadable(() => import('components/ContractIntroduction/OpenLimit'), {
//     ssr: false,
//     loading: true
// })
// const PriceHistory = loadable(() => import('components/ContractIntroduction/PriceHistory'), {
//     ssr: false,
//     loading: true
// })
// const PositionLevel = loadable(() => import('components/ContractIntroduction/PositionLevel'), {
//     ssr: false,
//     loading: true
// })
// const RiskPreparation = loadable(() => import('components/ContractIntroduction/RiskPreparation'), {
//     ssr: false,
//     loading: true
// })
// const DeliveryData = loadable(() => import('components/ContractIntroduction/DeliveryData'), {
//     ssr: false,
//     loading: true
// })

// export const Introduction = loadable(() => import('./Introduction'), {
//     loading: true
// })
// const Playground = loadable(() => import('./Playground'))
export const StrategyContainerNew = loadable(
  () => import("container/StrategyContainerNew"),
  {
    loading: true,
    ssr: false,
  }
);
const Strategy = loadable(() => import("./Strategy"), {
  loading: true,
  ssr: false,
});
const StrategyLineIndex = loadable(() => import("./StrategyLineIndex"), {
  loading: true,
  ssr: false,
});
// const BusinessLineIndex = loadable(() => import('./BusinessLineIndex'), {
//     loading: true
// })
// const SpotBusinessLineIndex = loadable(() => import('./SpotBusinessLineIndex'), {
//     loading: true
// })
// const Spot = loadable(() => import('./Spot'))
// const SpotContainer = loadable(() => import('container/SpotContainer'))
// const AssetsOverview = loadable(() => import('container/StrategyContainerNew/AssetsOverview'), {
//     ssr: false,
//     loading: true
// })
// export const FuturesHome = loadable(() => import('pages/FuturesHome'), {
//     loading: true
// })
// export const TradingBotHome = loadable(() => import("pages/TradingBotHome"), {
//   loading: true,
//   ssr: false,
// });

// const Crypto = loadable(() => import('pages/Crypto'), {
//     loading: true
// })
// export const CryptoHome = loadable(() => import('pages/Crypto/Home'), {
//     loading: true
// })
// const CryptoDetail = loadable(() => import('pages/Crypto/Detail'), {
//     loading: true
// })
// const Faq = loadable(() => import('pages/Crypto/Faq'), {
//     loading: true
// })
// const CryptoMyAssets = loadable(() => import('pages/Crypto/MyAssets'), {
//     loading: true
// })
const StrategyDetail = loadable(
  () => import("container/StrategyContainerNew/StrategyDetail"),
  {
    ssr: false,
    loading: true,
  }
);

// const TradeRuleLayout = loadable(() => import('container/TradeRuleLayout/index'), {
//     loading: true,
//     ssr: true
// })
// 基础交易规则
// export const SpotTradeRule = loadable(() => import('pages/SpotTradeRule/index'), {
//     loading: true,
//     ssr: true
// })

// const BasisRule = loadable(() => import('pages/SpotTradeRule/BasisRule/index'), {
//     loading: true,
//     ssr: true
// })

// const MarginInfo = loadable(() => import('pages/SpotMarginInfo/index'), {
//     loading: true,
//     ssr: true
// })

// const HotList = loadable(() => import('pages/FuturesHome/HotList'), {
//     loading: true,
//     ssr: false
// })

// const PreMarket = loadable(() => import('pages/PreMarket'), {
//     loading: true
// })
// const PreMarketH5BuyOrSell = loadable(() => import('pages/PreMarket/Trade/h5/BuyOrSell'), {
//     loading: true
// })
// const PreMarketH5PutOrder = loadable(() => import('pages/PreMarket/Trade/h5/PutOrder'), {
//     loading: true
// })

// const PreMarketOrders = loadable(() => import('pages/PreMarket/MyOrders'), {
//     loading: true
// })
// const PreMarketHome = loadable(() => import('pages/PreMarket/Home'), {
//     loading: true,
//     ssr: true
// })

export const GlobalRouterConfig: PreFetchRouteObject[] = [
  { path: "*", element: <Main /> },
  {
    path: "/:locales?",
    children: [
      // 合约首页
      // {
      //     path: 'futures',
      //     element: <FuturesHome />,
      //     id: 'futuresPage',
      //     loadData: [
      //         ...futureHomeLoadData,
      //         {
      //             queryKey: [tdkQueryKeys.TDK_INFO],
      //             queryFn: TDKServices.getFuturesHomeTranslationContent
      //         }
      //     ]
      // },
      // {
      //     path: 'futures/hot',
      //     element: <HotList />,
      //     id: 'futuresPage_hotList'
      // },
      // {
      //     path: 'futures',
      //     element: <Main topLevelBusinessType={'futures'} />,
      //     children: [
      //         {
      //             path: ':businessLine',
      //             element: <BusinessLine />,
      //             id: 'futuresBusinessLineIndex',
      //             children: [
      //                 {
      //                     path: '',
      //                     element: <BusinessLineIndex />
      //                 },
      //                 {
      //                     path: ':symbolId',
      //                     element: <ContractContainer />,
      //                     id: 'futuresOrderPage',
      //                     loadData: [
      //                         futuresTicker,
      //                         futuresPlaceConfig,
      //                         {
      //                             queryKey: [tdkQueryKeys.TDK_INFO],
      //                             queryFn: TDKServices.getFuturesTranslationContent
      //                         }
      //                     ]
      //                 }
      //             ]
      //         },
      //         {
      //             path: 'introduction',
      //             element: <TradeRuleLayout />,
      //             // element: <Introduction />,
      //             children: [
      //                 {
      //                     path: 'futures-summarize',
      //                     element: <FuturesOverview />
      //                 },
      //                 {
      //                     path: 'margin-summarize',
      //                     element: <MarginOverview />
      //                 },
      //                 {
      //                     path: 'liquidation-summarize',
      //                     element: <LiquidationOverview />
      //                 },
      //                 {
      //                     path: 'order-summarize',
      //                     element: <OrderOverview />
      //                 },
      //                 {
      //                     path: 'trading-fee',
      //                     element: <TradingFees />
      //                 },
      //                 {
      //                     path: 'futures-details',
      //                     element: <ContractDetails />
      //                 },
      //                 {
      //                     path: 'margin-discount-rate',
      //                     element: <MarginDiscountRate />
      //                 },
      //                 {
      //                     path: 'margin-exchange-rate',
      //                     element: <MarginExchangeRate />
      //                 },
      //                 {
      //                     path: 'futures-rate-record',
      //                     element: <RateRecord />
      //                 },
      //                 {
      //                     path: 'trading-parameters',
      //                     element: <TradingParameters />
      //                 },

      //                 {
      //                     path: 'funding-rate',
      //                     element: <FundsRate />
      //                 },
      //                 {
      //                     path: 'provision-for-risks',
      //                     element: <RiskPreparation />
      //                 },
      //                 {
      //                     path: 'delivery-data',
      //                     element: <DeliveryData />
      //                 },
      //                 {
      //                     path: 'position-tier',
      //                     element: <PositionLevel />
      //                 },
      //                 {
      //                     path: 'position-limit',
      //                     element: <OpenLimit />
      //                 },
      //                 {
      //                     path: 'price-indexes',
      //                     element: <PriceHistory />
      //                 }
      //             ].map(item => ({
      //                 ...item,
      //                 loadData: [
      //                     {
      //                         queryKey: [tdkQueryKeys.TDK_INFO],
      //                         queryFn: TDKServices.getFuturesInfoTranslationContent
      //                     }
      //                 ]
      //             }))
      //         },
      //         { path: 'playground', element: <Playground /> }
      //     ]
      // },
      // 策略详情页
      {
        path: "trading-bot/detail/:businessLine/:strategyId",
        element: <StrategyDetail />,
      },
      // 策略主页
      // {
      //   path: "trading-bot",
      //   element: <TradingBotHome />,
      //   loadData: [
      //     ...tradebotHomeLoadData,
      //     {
      //       queryKey: [tdkQueryKeys.TDK_INFO],
      //       queryFn: TDKServices.getTradingBotHomeTranslationContent,
      //     },
      //   ],
      // },
      {
        path: "trading-bot",
        element: <Main topLevelBusinessType={"strategy"} />,
        children: [
          // 处理en/trading-bot/ 和 en/trading-bot 的情况
          { path: "", element: <Navigate to="spot/btc-usdt" replace /> },
          //策略 交易
          // {
          //     path: 'futures',
          //     element: (
          //         <Strategy
          //             businessLine={BusinessLineEnum.USDT_MIX_CONTRACT_BL}
          //             line={StrategyBusinessLine.FUTURE_STRATEGY}
          //         />
          //     ),
          //     children: [
          //         //策略交易
          //         {
          //             path: '',
          //             element: (
          //                 <StrategyLineIndex
          //                     businessLine={BusinessLineEnum.USDT_MIX_CONTRACT_BL}
          //                     line={StrategyBusinessLine.SPOT_STRATEGY}
          //                 />
          //             )
          //         },
          //         {
          //             path: ':type?/:symbolId',
          //             element: <StrategyContainerNew />,

          //             loadData: [
          //                 getStrategyFuturesTicker,
          //                 {
          //                     queryKey: [tdkQueryKeys.TDK_INFO],
          //                     queryFn: TDKServices.getTradingBotTranslationContent
          //                 }
          //             ]
          //         }
          //     ]
          // },
          {
            path: "spot",
            element: (
              <Strategy
                businessLine={BusinessLineEnum.SPOT_BL}
                line={StrategyBusinessLine.SPOT_STRATEGY}
              />
            ),
            children: [
              //策略交易
              {
                path: "",
                element: (
                  <StrategyLineIndex
                    businessLine={BusinessLineEnum.SPOT_BL}
                    line={StrategyBusinessLine.SPOT_STRATEGY}
                  />
                ),
              },
              {
                path: ":type?/:symbolId",
                element: <StrategyContainerNew />,

                loadData: [
                  getStrategySpotTicker,
                  {
                    queryKey: [tdkQueryKeys.TDK_INFO],
                    queryFn: TDKServices.getTradingBotTranslationContent,
                  },
                ],
              },
            ],
          },
          // 未匹配路由跳转到spot/btc-usdt
          { path: "*", element: <Navigate to="spot/btc-usdt" replace /> },
        ],
      },
      // {
      //     path: 'spot',
      //     element: <TradeRuleLayout />,
      //     children: [
      //         {
      //             path: 'introduction',
      //             element: <SpotTradeRule />,
      //             children: [
      //                 {
      //                     path: 'spot-rules',
      //                     element: <BasisRule />
      //                 },
      //                 {
      //                     path: 'margininfo/:type?',
      //                     element: <MarginInfo />
      //                 }
      //             ]
      //         }
      //     ]
      // },
      // {
      //     path: 'spot',
      //     element: <Spot />,
      //     children: [
      //         //现货交易
      //         {
      //             path: '',
      //             element: <SpotBusinessLineIndex />
      //         },
      //         {
      //             path: ':symbolId',
      //             element: <SpotContainer />,
      //             loadData: [
      //                 spotTicker,
      //                 {
      //                     queryKey: [tdkQueryKeys.TDK_INFO],
      //                     queryFn: TDKServices.getSpotTranslationContent
      //                 }
      //             ]
      //         }
      //     ]
      // },
      // {
      //     path: 'strategy/assets',
      //     element: (
      //         <div className="body-wrapper">
      //             <AssetsOverview layout={SUPPORT_LAYOUT.right} />
      //         </div>
      //     ),
      //     children: []
      // },
      // {
      //     path: 'crypto-c2c',
      //     element: <Crypto />,
      //     children: [
      //         {
      //             path: ':quotation?',
      //             element: <CryptoHome />,
      //             loadData: [
      //                 ...cryptoHomeLoadData,
      //                 {
      //                     queryKey: [tdkQueryKeys.TDK_INFO],
      //                     queryFn: TDKServices.getC2CHomeTranslationContent
      //                 }
      //             ]
      //         },
      //         {
      //             path: ':quotation/:coinName/:type?',
      //             element: <CryptoDetail />
      //         },
      //         {
      //             path: 'app-assets',
      //             element: <CryptoMyAssets />
      //         },
      //         {
      //             path: 'faq',
      //             element: <Faq />
      //         }
      //     ]
      // },
      // {
      //     path: 'pre-market',
      //     element: <PreMarketHome />,
      //     id: 'pre-market-home',
      //     loadData: [
      //         {
      //             queryKey: [tdkQueryKeys.TDK_INFO, 'current'],
      //             queryFn: TDKServices.getC2CHomePreMarketTranslationContent
      //         },
      //         preMarketNewsProjectQuery,
      //         preMarketHistoryProjectQuery,
      //         preMarketBannerQuery,
      //         preMarketCoinConfigListQuery
      //     ]
      // },
      // {
      //     path: 'pre-market',
      //     element: <Crypto />,
      //     children: [
      //         {
      //             path: 'history',
      //             element: <CryptoHome />,
      //             loadData: [
      //                 {
      //                     queryKey: [tdkQueryKeys.TDK_INFO, 'history'],
      //                     queryFn: TDKServices.getC2CHomePreMarketTranslationContent
      //                 },
      //                 preMarketNewsProjectQuery,
      //                 preMarketHistoryProjectQuery,
      //                 preMarketBannerQuery,
      //                 preMarketCoinConfigListQuery
      //             ]
      //         },
      //         {
      //             path: ':coinName',
      //             element: <CryptoDetail />,
      //             loadData: [
      //                 {
      //                     queryKey: [tdkQueryKeys.TDK_INFO],
      //                     queryFn: TDKServices.getC2CDetailTranslationContent
      //                 },
      //                 preMarketNewsProjectQuery,
      //                 preMarketHistoryProjectQuery,
      //                 preMarketSpotTickerQuery,
      //                 preMarketCoinNewsQuery,
      //                 preMarketConfigsByMd5Query,
      //                 preMarketBannerQuery,
      //                 preMarketCoinConfigListQuery
      //             ]
      //         },
      //         {
      //             // H5买单卖单
      //             path: 'trade',
      //             element: <PreMarketH5BuyOrSell />,
      //             loadData: [
      //                 {
      //                     queryKey: [tdkQueryKeys.TDK_INFO],
      //                     queryFn: TDKServices.getC2CDetailTranslationContent
      //                 }
      //             ]
      //         },
      //         {
      //             // H5发布订单
      //             path: 'put-order',
      //             element: <PreMarketH5PutOrder />,
      //             loadData: [
      //                 {
      //                     queryKey: [tdkQueryKeys.TDK_INFO],
      //                     queryFn: TDKServices.getC2CDetailTranslationContent
      //                 },
      //                 preMarketNewsProjectQuery,
      //                 preMarketHistoryProjectQuery,
      //             ]
      //         },
      //         {
      //             path: 'app-assets',
      //             element: <Outlet />,
      //             children: [
      //                 {
      //                     path: '',
      //                     element: <PreMarketOrders />
      //                 },
      //                 {
      //                     path: 'all-orders',
      //                     element: <PreMarketOrders />
      //                 }
      //             ]
      //         },
      //         {
      //             path: 'faq',
      //             element: <Faq />
      //         }
      //     ]
      // }
    ],
  },
];
